<div class="layout-container">
    <side-panel *ngIf="menuTitle" [title]="menuTitle" side="left">
        <div header>
            <ng-content select="[menu-header]"></ng-content>
        </div>
        <div container class="summary-full-height">
            <ng-content select="[menu]"></ng-content>
        </div>
    </side-panel>

    <div class="center-container">
        <div class="header-container">
            <ng-content select="[header]"></ng-content>
        </div>
        <div class="main-container">
            <div *ngIf="isMainContainerLoading | async">
                <inner-loader></inner-loader>
            </div>

            <ng-content select="[main]"></ng-content>
        </div>
    </div>

    <side-panel *ngIf="summaryTitle" [title]="summaryTitle" side="right">
        <div header>
            <ng-content select="[summary-header]"></ng-content>
        </div>
        <div container class="summary-full-height">
            <ng-content select="[summary]"></ng-content>
        </div>
    </side-panel>
</div>
